
export default class CustomerLogin extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickRecoverBtn = this.onClickRecoverBtn.bind(this);
    this.onClickRecoverCancelBtn = this.onClickRecoverCancelBtn.bind(this);

    // privates
    this._node = this;
    this._login_form_zone = this._node.querySelector(".--login-form-zone");
    this._recover_form_zone = this._node.querySelector(".--recover-form-zone");
    this._recover_btn = this._node.querySelector(".--recover-btn");
    this._recover_cancel_btn = this._node.querySelector(".--recover-cancel-btn");

    // events
    this._recover_btn.addEventListener("click", this.onClickRecoverBtn);
    this._recover_cancel_btn.addEventListener("click", this.onClickRecoverCancelBtn);


    const recoverHash = window.location.hash.match(/\#recover/) ? true : false;
    const successMessage = this._node.querySelector(".success-msg") !== null;

    if (recoverHash || successMessage) {
      this._login_form_zone.style.display = "none";
      this._recover_form_zone.style.display = "block";
    } else {
      this._login_form_zone.style.display = "block";
    }
  }

  onClickRecoverBtn(e) {
    this._login_form_zone.style.display = "none";
    this._recover_form_zone.style.display = "block";
  }

  onClickRecoverCancelBtn(e) {
    this._login_form_zone.style.display = "block";
    this._recover_form_zone.style.display = "none";
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._recover_btn.removeEventListener("click", this.onClickRecoverBtn);
    this._recover_cancel_btn.removeEventListener("click", this.onClickRecoverCancelBtn);
  }
}
